import { AbstractControl, FormGroup } from '@angular/forms';

/**
 * Trims all string values in a FormGroup (including nested FormGroups).
 * Call this at the very start of every submit handler, before markAllAsTouched(),
 * so that whitespace-only required fields are caught by Validators.required.
 * Email controls (those with Validators.email) have ALL spaces stripped.
 */
export function trimFormGroup(form: FormGroup): void {
  Object.values(form.controls).forEach((control: AbstractControl) => {
    if (control instanceof FormGroup) {
      trimFormGroup(control);
    } else if (typeof control.value === 'string') {
      // Detect email controls: Validators.email is registered as a validator
      const validators: unknown[] = (control as any)._rawValidators ?? [];
      const hasEmailValidator = Array.isArray(validators) && validators.some(
        (v) => typeof v === 'function' && v.name === 'email'
      );
      const cleaned = hasEmailValidator
        ? control.value.replace(/\s/g, '')
        : control.value.trim();
      if (control.value !== cleaned) {
        control.setValue(cleaned, { emitEvent: false });
      }
    }
  });
}
